<template>
  <LineAdjustmentsEditor
    :lineItem="lineItem"
    :disabled="disabled"
    :saving="saving"
    :hideSave="hideSave"
    :hideTotals="hideTotals"
    :getSubtotal="item => item.subtotal || 0"
    :getEffectiveTotal="item => item.effective_total || 0"
    @saveAdjustments="$emit('saveAdjustments', $event)"
    @update:adjustments="$emit('update:adjustments', $event)"
  />
</template>

<script>
import LineAdjustmentsEditor from '@/components/accounting/LineAdjustmentsEditor'

export default {
  name: 'MovementLineAdjustments',
  components: { LineAdjustmentsEditor },
  props: {
    lineItem: Object,
    disabled: Boolean,
    saving: Boolean,
    hideSave: Boolean,
    hideTotals: Boolean
  },
  emits: ['saveAdjustments', 'update:adjustments']
}
</script>
